import React, { useState } from "react";
import { useFormik } from "formik";
import { Col, Form, Input, Modal, ModalBody, Row } from "reactstrap";
import _ from "lodash";
import Title from "../../../../components/title";
import * as Yup from "yup";
import { store } from "../../../../redux/storeConfig/store";
import PartialPaymentDialog from "./PartialPaymentDialog";
import { toastr } from "react-redux-toastr";

const PaymentTypesDialog = ({
  modalFlg,
  toggle,
  currentTransactionType,
  hanldeSubmit,
  type,
  currentRemainingAmount,
}) => {
  const setModalFlag = () => toggle(!modalFlg);

  const validationSchema = Yup.object().shape({
    paymentType: Yup.string().required("payment type is required"),
  });
  const formik = useFormik({
    initialValues: {
      paymentType: currentTransactionType?currentTransactionType:"L",
      receivedAmount: 0,
      remainingAmount: currentRemainingAmount ? currentRemainingAmount : 0,
      paymentStatus: null,
    },
    onSubmit: (values) => {
      let { cardProcessingFees } = store.getState().gym.gym;
      if (type == "settelment" && !values.paymentStatus)
        return toastr.error(
          "Please Select Full or Partial Payment to procceed"
        );
      hanldeSubmit(
        values.paymentType,
        cardProcessingFees,
        values?.receivedAmount,
        values?.paymentStatus
      );
      setModalFlag();
    },
    validationSchema: validationSchema,
  });

  return (
    <>
      <Modal isOpen={modalFlg} toggle={setModalFlag} centered={true} size="md">
        <ModalBody className="body-layout-main-block">
          <div className="basic-info">
            <div className="info-title with-border">
              <Title
                title={`Choose Payment Type`}
                titlestyle=""
                subtitlestyle="ctf-tx-secondary"
              />
            </div>

            <Form onSubmit={formik.handleSubmit}>
              <div className="trainer-gender-default-wrapper border-bottom-1 blk-padding-y">
                <div className="status-inner-block">
                  <div className="status-inner-block">
                    <Row>
                      {type == "settelment" ? (
                        <Col md={12} className="mb-5">
                          <PartialPaymentDialog
                            setFieldValue={formik?.setFieldValue}
                            values={formik?.values}
                            currentRemainingAmount={currentRemainingAmount}
                          />
                        </Col>
                      ) : null}

                      <Col md={3}>
                        <div
                          className="form-check form-check-inline custom-btn-radio"
                          checked
                        >
                          <Input
                            type="radio"
                            name="paymentType"
                            id="cash"
                            value="L"
                            className="form-check-input"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "paymentType",
                                e.target.value
                              )
                            }
                            defaultChecked={
                              currentTransactionType === "L" ||
                              !currentTransactionType ||
                              currentTransactionType === "SP"
                            } // Set defaultChecked based on the default value
                          />

                          <label
                            className="form-check-label label-blk"
                            style={{ fontSize: "15px" }}
                            for="cash"
                          >
                            Cash
                          </label>
                        </div>
                      </Col>
                      <Col md={3}>
                        <Input
                          type="radio"
                          name="paymentType"
                          id="Cheque"
                          value="CQ"
                          className="form-check-input"
                          onChange={(e) =>
                            formik.setFieldValue("paymentType", e.target.value)
                          }
                          defaultChecked={currentTransactionType === "CQ"} // Set defaultChecked based on the default value
                        />
                        <label
                          className="form-check-label label-blk"
                          for="Cheque"
                          style={{ fontSize: "15px" }}
                        >
                          Cheque
                        </label>
                      </Col>
                      <Col md={3}>
                        <Input
                          type="radio"
                          name="paymentType"
                          id="visa"
                          value="CC"
                          className="form-check-input"
                          onChange={(e) =>
                            formik.setFieldValue("paymentType", e.target.value)
                          }
                          defaultChecked={currentTransactionType === "CC"} // Set defaultChecked based on the default value
                        />

                        <label
                          className="form-check-label label-blk"
                          style={{ fontSize: "15px" }}
                          for="visa"
                        >
                          Visa/MC
                        </label>
                      </Col>
                      <Col md={3}>
                        <Input
                          type="radio"
                          name="paymentType"
                          id="bank"
                          value="BA"
                          className="form-check-input"
                          onChange={(e) =>
                            formik.setFieldValue("paymentType", e.target.value)
                          }
                          defaultChecked={currentTransactionType === "BA"} // Set defaultChecked based on the default value
                        />
                        <label
                          className="form-check-label label-blk complementary-radio-add-sale"
                          style={{ fontSize: "15px" }}
                          for="bank"
                        >
                          Bank
                        </label>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
              <div className="action-btn-block pl-3">
                <button
                  type="button"
                  value="Cancel"
                  className="btn btn-medium btn-transparent"
                  onClick={setModalFlag}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  value="Save Changes"
                  className="btn btn-medium"
                >
                  Save Change
                </button>
              </div>
            </Form>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};
export default PaymentTypesDialog;
